import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdAdd, MdDownload } from 'react-icons/md';

interface SidebarCTAProps {
  isCollapsed: boolean;
}

const SidebarCTA: React.FC<SidebarCTAProps> = ({ isCollapsed }) => {
  return (
    <div className="p-4 border-t border-[#616161]/20">
      <AnimatePresence mode="wait">
        {!isCollapsed ? (
          // Expanded CTA Card
          <motion.div
            key="expanded"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="bg-gradient-to-br from-[#000000] to-[#1a1a1a] rounded-2xl p-6 border border-[#616161]/20"
          >
            {/* <h3 className="text-white text-lg font-semibold mb-2">
              Let's start!
            </h3> */}
            <p className="text-[#9E9E9E] text-xs mb-4 leading-relaxed">
              Generate AI-powered campaigns and boost your restaurant's marketing
            </p>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="w-full bg-[#EE4423] text-white cursor-pointer font-medium py-2 px-3 rounded-xl flex items-center justify-center gap-2 transition-all"
            >
              {/* <MdAdd size={20} /> */}
              <span>Download Book</span>
            </motion.button>
          </motion.div>
        ) : (
          // Collapsed CTA Button with Download Icon
          <motion.button
            key="collapsed"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.2 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="w-12 h-12 mx-auto bg-[#EE4423] hover:bg-[#d63d20] text-white rounded-xl flex items-center justify-center transition-all shadow-lg shadow-orange-500/20 group relative"
          >
            <MdDownload size={22} />
            
            {/* Tooltip */}
            <div className="absolute left-full ml-2 px-3 py-2 bg-[#212121] text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-50 border border-[#616161]/20">
              Download Book
            </div>
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SidebarCTA;
